import styled from "styled-components";

export const StudentManagementCss = styled.div`
    width: 100%;

    /** Box **/
    .box{
        width: 100%;
        display: flex;
        align-items: flex-start;
        background-color: #fff;
        margin-top: 25px;
        flex-direction: row;
        padding: 10px 0 20px 15px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }

    .centered {
        flex-direction: column;
        align-items: center;
    }

    .userName{
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #87868F;
            margin:25px 0 0 100px;
            font-family: 'Quicksand', sans-serif;
        }
    }

    .viewUser{
        display: flex;
        width: 100%;
        flex-direction: row;
    }

    .MuiInput-underline-15:before {
        border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
        border-bottom: none;
    }

    /** Personal**/
    .changePhoto{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        /* width: 100%; */
        margin: 40px 85px 0 25px;

        h2{
            color: #403F4C;
            font-size: 14px;
            margin-bottom: 10px;
        }

        .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            input.upload {
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 20px;
                cursor: pointer;
                opacity: 0;
                filter: alpha(opacity=0);
            }

            span{
                display: flex;
                align-items: center;
            }
        }

        span{
            img{
                padding: 0 5px 0 0;
            }
        }

    }

    /** Form **/
    .formulario{
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin: 40px 100px 0 0;

        label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
        }

        .addEmail{
            display: flex;

            input{
                width: 460px;
            }
        }

        .label{
            margin: 0 0 -15px 0;
        }

        span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
        }

        span.invalid {
            font-size: 10px;
            margin-left: 5px;
            /* color: red; */
        }
        select{
            width: 220px;
            height: 35px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            color: #403F4C;
            font-family: 'Quicksand',sans-serif;
            font-size: 14px;
            margin-top: 2px;
        }


        .profile{
            display: flex;
            justify-content: flex-start;
            /* width: 100%; */
            /* max-width: 59%; */

            /* select{
                width: 220px;
                &:last-child{
                    display: none;
                }
            } */

            /* .role{
                width: 100%;
                max-width: 34%;
            } */

            .active{
                background-color: #00D36A;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
            }
        }

        input{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            padding-left: 10px;
            margin-bottom: 15px;
            background-color: transparent;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            margin-top: 2px;
        }

        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #87868F;
        }

        .addInput{
            width: 128px;
            height: 32px;
            border-radius: 26px;
            margin: 0 24px;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #87868F;
            cursor: pointer;
            font-family: 'Work Sans', sans-serif;
        }

        input:invalid{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            /* border: 1px solid red; */
            padding-left: 10px;
            margin-bottom: 15px;
        }

        .timezoneCard{
                div:nth-child(2){
                  width: 480px !important;

                  input{
                    width: 100% !important;
                  }
                  ul{
                    width: 480px !important;
                    li{
                      width: 100% !important;
                      button{
                        width: 100% !important;
                      }
                    }
                  }
                }
              }

        .inputs{
            display: flex;



        .lineInputs{
            margin-right: 23px;

            button{
                margin: 24px 0 0 -6px;
                width: 175px;
                padding: 0 12px;
                margin-bottom: 48px;
            }

            .gender{
                width: 243px;
            }

            .MuiInput-input-14 {
                width: 215px;
                border: none;
                height: 19px;
                margin: 0;
            }

            .MuiFormControl-root-30 {
                border: 1px solid;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
            }

            input{
                width: 220px;
            }

            select.userPhoneTypeId{
                width: 300px;
            }

        }

        p{
            font-size: 11px;
            color: #87868F;
            margin-top: 22px;
        }

    }


        .telephone{
            input{
                width: 220px;
            }

            button.addInput{
                margin: 20px 0 0 0;
                font-family: 'Work Sans', sans-serif;
            }
        }

        button.addInput{
            width: 132px;
            height: 32px;
            border-radius: 26px;
            margin-left: 20px;
            background: transparent;
            border: 1px solid #403F4C;
            color: #403F4C;
            font-family: 'Work Sans', sans-serif;
            font-size: 14px;
            cursor: pointer;
            margin-bottom: 22px;
            font-weight: 500;
        }

        button.password{
            width: 158px;
            height: 32px;
            border-radius: 26px;
            margin-left: 0;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            cursor: pointer;
            font-weight: 100;
            margin: 2px 0 44px 0;
        }

        .notification{
            display: flex;

            .switch__container{
                margin: 5px 0 0 23px;

                span{
                    margin-left: 47px;
                    font-size: 12px;
                    color: #707070;
                    font-family: 'Quicksand', sans-serif;
                }
            }

            span.delete{
                margin: 11px 0 0 0;
                width: 55px;
                font-weight: bold;
            }
        }

        .switchBox{
            display: flex;

            .labelNotify{
              display: flex;
              flex-direction: column;
              width: auto;

              .doubleClick{
                color: #ccc !important;
              }
            }
        }



        // select{
        //     width: 220px;
        //     height: 32px;
        //     border-radius: 26px;
        //     border: 1px solid #403F4C;
        //     padding-left: 10px;
        //     margin-bottom: 15px;
        // }

        .selects{
            display: flex;
            flex-direction: row;

        }

        .lineSelect{
            margin: 0 25px 0 0;

            p{
                font-size: 11px;
                margin-top: 22px;
                color: #403F4C;
            }
        }

        span.delete {
            color: red;
            font-size: 10px;
            font-weight: bold;
            margin-top: 30px;
            float: left;
        }


        button{
            background-color: #004FFF;
            border: none;
            color: #fff;
            font-weight: bold;
            font-size: 11px;
            border-radius: 26px;
            width: 81px;
            height: 38px;
            margin: 15px 0 42px 0;
            cursor: pointer;
        }

        button.jsx-4179805763    {
            width: 226px !important;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 0;
            margin-top: 0;
        }

        button.jsx-4179805763  {
            margin: 0 0 1px 0 !important;
            background: #B2B2B7;
            border-radius: 0;
        }
        button.focus.jsx-4179805763  {
            background: #B2B2B7;
        }

        button.delete{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: none;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 10px;

        }

    }

    /** Button Save **/
    .buttonSave{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
            width: 81px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;
            font-family: 'Quicksand', sans-serif;

            .fa{
                margin-right: 3px;
            }
        }
    }

    input.jsx-4179805763  {
        width: 475px;
        height: 32px;
        border-radius: 26px;
        border: 1px solid #B2B2B7;
        padding-left: 10px;
        margin-bottom: 15px !important;
    }

    /** Plans **/
    .planBox{

        .box {
            flex-direction: column;
            padding: 0;

            &:last-child{
                margin-bottom: 85px;
            }

            .buttons{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                margin: 25px 35px 25px 0;
                padding: 0 15px 0 15px;
                cursor: pointer;

                button {
                    background-color: transparent;
                    border: 1px solid #787780;
                    color: #403F4C;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 71px;
                    height: 38px;
                    margin-top: 8px;
                    cursor: pointer;

                    &:last-child{
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 81px;
                        height: 38px;
                        margin-top: 5px;
                        margin-left: 15px;
                        cursor: pointer;
                    }
                }
            }
        }

        .PlansBox {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: space-between;
            flex-wrap: wrap;

            &:last-child{
                margin-bottom: 25px;
            }

            .chosenPlan {
                flex-direction: row;
                display: flex;
                margin: 0;
                width: 100%;
                height: 80px;
                padding: 10px 0 0 15px;
                margin-left: 13px;
                flex-wrap: wrap;

            h2 {
                    padding: 0 30px 0 0;
                    font-size: 15px;
                    color: #403F4C;
                    font-weight: bold;
                    margin: 0;
                }

                h3 {
                    padding: 0;
                    margin: 0;
                    font-size: 18px;
                    color: #403F4C;
                    font-weight: bold;
                }

                p {
                    color: #403F4C;
                    font-size: 15px;
                    padding: 0;
                    margin: 0 0 5px 0;
                }

                button {
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 86px;
                    height: 28px;
                    margin-top: 5px;
                    cursor: pointer;

                    &:last-child {
                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #B2B2B7;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 93px;
                        height: 28px;
                        margin: 5px 0 26px 10px;
                        cursor: pointer;
                    }
                }

            }

            .last {
                margin-bottom: 20px;
            }

            .detalhesBTN {
                flex-direction: column;

                .extrasClasses{
                    margin-top: 6px;
                }
            }

            .plans {
                display: flex;
                margin: 20px 85px 0 20px;

                .changePlan {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    padding-left: 10px;

                    h2 {
                        color: #403F4C;
                        font-size: 18px;
                        font-weight: bold;
                        margin-top: 6px;
                    }

                    button {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 86px;
                        height: 22px;
                        margin-top: 5px;
                        cursor: pointer;
                        font-family: 'Quicksand', sans-serif;

                        &:last-child {
                            background-color: #fff;
                            border: 1px solid #B2B2B7;
                            color: #B2B2B7;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 93px;
                            height: 22px;
                            margin-top: 5px;
                            cursor: pointer;
                        }

                        .fa{
                            margin-left: 10px;
                        }
                    }
                }

                /** Controle Plano **/
                .controlPlan{
                    display: flex;
                    flex-direction: row;
                    align-items: start;
                    width: 100%;

                    .infos{
                        flex-direction: column;
                        margin: 8px 25px 0 0;
                    }

                    h2{
                        font-size: 13px;
                        color: #9E9EA4;
                        font-weight: bold;
                        margin: 0;
                        padding: 0;
                        font-family: 'Quicksand', sans-serif;
                    }

                    h3{
                        font-size: 14px;
                        color: #403F4C;
                        margin: 3px 0 0 0;
                        padding: 0;
                        font-family: 'Quicksand',sans-serif;
                        font-weight: 100;
                    }

                    span{
                        color: #004FFF;
                        font-size: 22px;
                        font-weight: bold;

                        &:last-child{
                            color: #004FFF;
                            font-size: 14px;
                            font-weight: 50
                        }
                    }
                }

                /** Números **/
                .numbers{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: -3px;
                }

                /** Stock **/
                .stock{
                    hr {
                        height: 4px;
                        background-color: #004FFF;
                        width: 100%;
                        border: none;
                        margin: 9px 0 10px 0;
                        opacity: 1;
                    }

                    span{
                        color: #004FFF;
                        font-size: 12px;
                    }
                }


                /** Pagamento **/
                .payment{
                    flex-direction: column;
                    margin-top: 7px;
                    width: 150px;

                    h2{
                        font-size: 14px;
                        color: #9E9EA4;
                        font-weight: bold;
                        margin: 0;
                        padding: 0;
                        font-family: 'Quicksand',sans-serif;
                        text-transform: uppercase;
                        padding-bottom: 5px;
                    }

                    h3{
                        font-size: 16px;
                        color: #403F4C ;
                        margin: 0;
                        padding: 0;
                        font-family: 'Quicksand',sans-serif;
                        font-weight: 100;
                        display: flex;
                        align-items: center;

                        img{
                            margin-right: 8px;
                            width: 30px !important;
                            height: 20px !important;
                        }
                    }

                    button{
                        background-color: transparent;
                        border: 1px solid #FF5666;
                        color: #FF5666;
                        font-size: 11px;
                        border-radius: 26px;
                        width: auto;
                        height: 22px;
                        margin-top: 8px;
                        padding: 0 12px 0 12px;
                        cursor: pointer;
                    }

                    select {
                        width: 100%;
                        height: 38px;
                        border-radius: 26px;
                        border: 1px solid #403F4C;
                        padding-left: 10px;
                        margin-bottom: 15px;
                        color: #403F4C;
                        margin-right: 10px;
                        opacity: 0.4;
                    }
                }



                /** Valores **/
                .value {
                    margin-top: 8px;

                    h2{
                        font-size: 15px;
                        color: #87868F;
                        font-weight: bold;
                        margin: 0;
                        padding: 0;
                    }

                    h3{
                        font-size: 18px;
                        color: #403F4C;
                        font-weight: normal;
                        margin-top: 4px;
                        margin: 0;
                        padding: 0;
                    }

                    button{
                        background-color: #fff;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 94px;
                        height: 22px;
                        margin-top: 8px;
                        cursor: pointer;
                    }

                }

                &:nth-child(2) {
                    flex-direction: column;
                }

                &:last-child button{

                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #787881;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 104px;
                    height: 22px;
                    margin-top: 5px;
                    cursor: pointer;
                    font-family: 'Quicksand', sans-serif;

                    .fa{
                        margin-left: 7px;
                    }
                }

                .buttons{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 25px;
                    padding: 0 15px 0 15px;
                    cursor: pointer;

                    button{
                        background-color: transparent;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 71px;
                        height: 38px;
                        margin-top: 8px;
                        cursor: pointer;

                        &:last-child{
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 81px;
                            height: 38px;
                            margin-top: 5px;
                            cursor: pointer;
                        }
                    }

                    .cancel{
                        button{
                            background-color: transparent;
                            border: 1px solid #FF5666;
                            color: #FF5666;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 104px;
                            height: 22px;
                            margin-top: 5px;
                            cursor: pointer;
                        }
                    }
                }

            }

            .planCancel{
                background-color: #FF5666;
                color: #fff;
                padding: 4px 10px 0 10px;
                height: 23px;
                margin-top: 32px;
                font-size: 15px;
                font-weight: bold;
                font-family: 'Quicksand', sans-serif;
            }
        }
    }

    /** box Big **/
    .boxBig {
        width: 100%;
        padding: 10px 20px 0 0;
        margin: 0 auto;


        button {
            background-color: #fff;
            border: 1px solid #403F4C;
            color: #403F4C;
            font-size: 13px;
            border-radius: 26px;
            width: auto;
            height: 28px;
            margin-top: 0;
            cursor: pointer;
            padding: 0 12px 0 12px;
            float: right;
            display: block;
            font-family: 'Work Sans',sans-serif;
        }

        button.active {
            background-color: #004FFF;
            color: #fff;
            border: #004FFF;
            height: 32px;
            font-weight: 900;
            font-family: 'Work Sans', sans-serif;
            padding: 0 25px 0 25px;
        }

        .buttons{
            display: flex;
            justify-content: flex-end;
            font-family: 'Quicksand', sans-serif;
            align-items: center;
        }

        .itemBox {
            display: flex;
            justify-content: space-between;
            width: 100%;
            flex-wrap: nowrap;
            flex-direction: row;
            margin: 0 0 27px 0;
            align-items: normal;

            &:first-child {
                border-bottom: 1px solid #D9D8DB;
            }

            .buttonLast{
                margin: 28px 0 0 0;
                width: 135px;


            }

            h5{
                padding: 0;
                margin: 0 0 10px 0;
                font-weight: 100;
                color: #403F4C;
                font-size: 14px;

                /* &:last-child{
                    margin: 15px 0 7px 0 !important;
                } */
            }

            span{
                color: #004FFF;
                font-weight: 500;

                strong{
                    font-weight: bold;
                }
            }


            input{
                width: 90%;
                height: 29px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                background-color: transparent;
                font-family: 'Quicksand',sans-serif;
                font-size: 14px;
            }

            select{
                width: auto;
                height: 34px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding: 0 25px 0 25px;
                margin-bottom: 15px;
                color: #403F4C;
                opacity: 0.4;
            }

            .levelTop {
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                width: 100%;
                max-width: 260px;

                .levelTopLinguage {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .boxLanguage {
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        flex-direction: column;

                        h5{
                            padding: 0;
                            margin: 0;
                            color: #9F9FA5;
                            font-size: 15px;
                            font-weight: bold;
                        }

                        .language {
                            display: flex;
                            margin: 0 0 13px 0;
                            align-items: center;

                            img {
                                margin: 0 8px 0 0;
                                width: 30px !important;
                                height: 20px !important;
                            }

                            h5{
                                font-size: 16px;
                                color: #403F4C;
                                margin: 0;
                                padding: 0;
                                font-family: 'Quicksand',sans-serif;
                                font-weight: 100;
                            }
                        }


                    }

                    .boxLevel {
                        display: flex;
                        align-items: end;
                        align-content: flex-end;
                        flex-direction: column;
                        width: 100%;
                        text-align: left;
                        margin-left: 36px;


                        h5{
                            font-size: 15px;
                            color: #403F4C;
                            margin: 0 0 8px 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;

                            &:first-child{
                                font-weight: bold;
                                color: #9F9FA5;
                            }
                        }
                    }

                }

                .columLevel {
                    justify-content: flex-end;
                    display: flex;
                    width: 100%;

                    h5 {
                        text-align: right;
                        padding: 0;
                        margin: 0;
                        color: #87868F;
                    }

                }
            }



            .grades {
                display: flex;
                flex-direction: row;
                width: 139px;

                h6 {
                    margin: 28px 10px 0 0;
                    color: #9F9FA5;
                    font-size: 15px;
                    font-family: 'Quicksand', sans-serif;
                    font-weight: bold;
                    width: 70px;
                }

                h5{
                    padding: 0;
                    margin: 0 0 10px 0;
                    color: #403F4C;
                    font-size: 14px;
                    font-family: 'Quicksand', sans-serif;
                    font-weight: normal;

                    span {
                        color: #004FFF;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    /** Notifications **/
    .infoNotification {
        width: 100%;

        h2 {
            color: #403F4C;
            font-size: 18px;
            margin: 40px 0 0 52px;
            font-weight: 100;
            font-family: 'Quicksand', sans-serif;
        }

        ul {
            margin: 40px 0 0 57px;
            display: flex;
            width: 88%;
            flex-direction: column;

        li {
                display: flex;
                align-items: center;
                padding: 0;
                margin: 0;
                height: 50px;

                span {
                    width: 70px;
                    //margin: -23px 25px 0 0;
                    color: #403F4C;
                    //font-weight: bold;
                    font-size: 16px;
                    font-family: 'Quicksand', sans-serif;
                }

            }
        }
    }

    /** Manage Available Hours **/
    .topManage {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        margin: 15px 25px 0 0;
        align-items: center;

        h2 {
            font-size: 18px;
            color: #403F4C;
            font-weight: normal;
        }

        button {
            background-color: #004FFF;
            border: none;
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            border-radius: 26px;
            width: auto;
            height: 38px;
            margin-top: 5px;
            padding: 12px;
            cursor: pointer;
            font-family: 'Work Sans', sans-serif;
        }
    }

    .manage {
        display: flex;
        width: 100%;
        justify-content: start;
        flex-direction: column;

        .day {
            display: flex;
            align-items: center;
            flex-direction: row;
            margin: 10px 0 10px 0;
        }

        h2 {
            font-size: 14px;
            color: #004FFF;
            font-weight: 500;
            font-family: 'Work Sans', sans-serif;
        }

        p{
            color: #C5C5C5
        }

        button {
            background-color: #004FFF;
            border: none;
            color: #fff;
            font-size: 11px;
            font-weight: bold;
            border-radius: 26px;
            width: 44px;
            height: 22px;
            margin: 5px 0 0 16px;
            cursor: pointer;
        }

        ul {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            list-style: none;
            padding: 0;

            .configDay {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: row;
                margin: 0 30px 0 0;
            }

            li {
                font-size: 14px;
                color: #403F4C;
                padding: 0 5px 0 0;

            span {
                    color: red;
                    font-size: 12px;
                }

                button {
                    background-color: white;
                    width: 55px;
                    cursor: pointer;
                    color: red;
                    font-size: 12px;
                    margin: 0;
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 500;
                }

            }
        }

    }

    /** Edit **/
    .selectDays{
        margin: 35px 0 0 28px;

        h2 {
            color: #403F4C;
            font-size: 28px;
            margin: 0;
            font-family: 'Quicksand',sans-serif;
            font-weight: 100;
        }

        h3 {
            color: #403F4C;
            font-size: 12px;
            margin: 0;
        }

        h4 {
            color: #403F4C;
            font-size: 14px;
            margin: 25px 0 0 0;
        }

        ul {
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            justify-content: start;
            list-style: none;
            padding: 0;

            li {
                margin: 0 10px 0 0;
                padding: 5px 0 0 0;

                span{
                    font-size: 12px;
                    color: #403F4C;
                    margin-top: 5px;
                    font-family: 'Quicksand', sans-serif;
                }

                button {
                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #B2B2B7;
                    font-size: 14px;
                    border-radius: 26px;
                    width: 76px;
                    height: 28px;
                    margin-top: 0;
                    cursor: pointer;
                }

                button.active {
                    background-color: #004FFF;
                    color: #fff;
                    border: #004FFF;
                }
            }
        }

        .time{
            ul {
                list-style: none;
                margin-left: 24px;

                li {
                    display: flex;
                    flex-direction: column;
                }
            }

            select {
                background-color: #004FFF;
                color: #fff;
                border-radius: 26px;
                border: 0;
                width: 114px;
                height: 28px;
                padding-left: 10px;
                font-family: 'Work Sans', sans-serif;
                font-size: 14px;
                margin-top: 5px;
            }
        }

        .addSlot{
            button {
                background-color: #fff;
                border: 1px solid #B2B2B7;
                color: #B2B2B7;
                font-size: 14px;
                border-radius: 26px;
                width: 162px;
                height: 28px;
                margin: 20px 0 36px 24px;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
                font-weight: 500;
            }
        }

        .buttons {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            margin: 25px;
            padding: 0 15px 0 15px;
            cursor: pointer;
            font-family: 'Quicksand', sans-serif;

            button {
                background-color: transparent;
                border: 1px solid #787780;
                color: #403F4C;
                font-weight: bold;
                font-size: 11px;
                border-radius: 26px;
                width: 71px;
                height: 28px;
                margin-top: 8px;
                cursor: pointer;

                .fa{
                    margin-right: 5px;
                }

                &:last-child {
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 81px;
                    height: 38px;
                    margin-left: 15px;
                    margin-top: 5px;
                    cursor: pointer;
                }
            }
        }
    }

    .pagamento{
        display: flex;
    }

    .inputManage{
        border-color: #B2B2B7 !important;
    }
`;

export const FilterCss = styled(StudentManagementCss)`
    h2{
        font-size: 20px;
        font-weight: 400;
        color: #87868F;
        font-family: 'Quicksand', sans-serif;
        .fa{
            margin: 0 5px 0 0;
        }
    }

    .formulario{
        flex-direction: row;
        margin: 10px 0 0 0;

        .lineInput{
            display: flex;
            flex-direction: column;
            margin: 0 16px 0 0;
            width: 100%;
        }

        input {
            width: auto;

        }

        select{
            width: auto;
        }
    }

    .button{
        display: flex;
        justify-content: flex-end;
        width: 100%;

        button{
            width: 149px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 0 0 20px 0;
        }
    }

    .buttons{
        display: flex;
        justify-content: flex-end;
        font-family: 'Quicksand', sans-serif;
        align-items: center;

        .Users-wrapper-2 {
            position: relative;
            width: 81px;
            height: 28px;
        }
        button{
            width: 84px;
            height: 22px;
            border-radius: 26px;
            background: #fff;
            border: 1px solid #B2B2B7;
            color: #B2B2B7;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 14px 0 0 0;
            margin-right: 10px;
            font-family: 'Quicksand', sans-serif;

            &:last-child{
                width: auto;
                height: 32px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: 500;
                margin: 18px 18px 0 0;
                padding: 0 12px 0 12px;
            }


            &:disabled,
                button[disabled]{
                width: 58px;
            }

        }

        button.save {
            width: 81px;
            height: 22px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 10px 18px 0 0;
            font-family: 'Work Sans', sans-serif;
        }
    }
`;

export const Manage = styled.div`
  width: 95%;
  max-width: 1300px;
  margin: 0 auto;

    h3{
        font-size: 22px;
        color: #004FFF;
        font-weight: bold;
        font-family: 'Quicksand', sans-serif;
        margin: 20px 0;
        width: 100%;
        max-width: 66%;
        text-align: center;
    }


    .tabs{
        width: 100%;

        .tab-content{
            margin-bottom: 36px;

            .buttons-plans {
                display: flex;
                flex-direction: column;
                align-items: flex-end !important;

                .button-buy-more {
                    background-color: #004FFF !important;
                    color: #fff !important;
                    font-size: 11px;
                    font-family: "Quiscksand", sans-serif;
                    font-weight: 500;
                    width: auto !important;
                    height: auto !important;
                    padding: 6px 10px;
                    white-space: nowrap;
                    margin-top: 7px !important;
                    border: none !important;
                }
            }

            .buttons{
                display: flex;
                justify-content: center;
                margin-top: 10px;

                button{
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 26px;
                    width: auto;
                    height: 38px;
                    margin-top: 50px;
                    cursor: pointer;
                    font-family: 'Work Sans', sans-serif;
                    font-weight: 900;
                    padding: 0 12px 0 12px;

                }
            }
        }

        /** Tabs **/
        .tab-list {
            padding-left: 0;

            .tabsContent{
                margin: 0 auto;
                width: 100%;
                text-align: center;

                .tab-list-item {
                    display: inline-block;
                    list-style: none;
                    cursor: pointer;
                    font-size: 15px;
                    font-family: 'Quicksand', sans-serif;
                    color: #ffffff;
                    font-weight: 600;
                }

                .tab-list-active {
                    color: #ffffff;
                    font-weight: 700;
                    border-bottom: none;
                    font-size: 15px;
                    font-family: 'Quicksand', sans-serif
                }
            }
        }

        /** Box **/
        .box{
            width: unset;
            height: 100%;
            background-color: #fff;
            margin-top: 25px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: row;
            padding: 15px 15px;
            gap: 10px;
            border-radius: 10px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
            flex-wrap: wrap;




        }


        .userName{
            h2{
                font-size: 24px;
                font-weight: 500;
                color: #87868F;
                margin:25px 0 0 100px;
                font-family: 'Quicksand', sans-serif;
            }
        }

        .viewUser{
            display: flex;
            width: 100%;
            flex-direction: row;
        }

        .MuiInput-underline-15:before {
            border-bottom: none;
        }

        .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
            border-bottom: none;
        }

        /** Personal**/
        .changePhoto{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 20%;

            h2{
                color: #403F4C;
                font-size: 14px;
                margin: 0 0 10px 0 !important;
            }

            .photo{
                display: flex;
                align-items: center;
                flex-direction: column;
            }

            .fileUpload {
                position: relative;
                overflow: hidden;
                margin: 10px;
                border-radius: 26px;
                border: 1px solid #787780;
                width: 93px;
                height: 20px;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                input.upload {
                    position: absolute;
                    top: 0;
                    right: 0;
                    margin: 0;
                    padding: 0;
                    font-size: 20px;
                    cursor: pointer;
                    opacity: 0;
                    filter: alpha(opacity=0);
                }

                span{
                    display: flex;
                    align-items: center;
                }
            }

            span{
                img{
                    padding: 0 5px 0 0;
                }
            }

        }

        /** Form **/
        .formulario{
            display: flex;
            justify-content: center;
            flex-direction: column;

            label{
                color: #403F4C;
                font-size: 14px;
                font-weight: bold;
            }

            .addEmail{
                display: flex;

                input{
                    width: 460px;
                }
            }

            .label{
                margin: 0 0 -15px 0;
            }

            span{
                color: #87868F;
                font-size: 10px;
                margin-left: 5px;
            }

            span.invalid {
                font-size: 10px;
                margin-left: 5px;
                color: red;
            }
            select{
                width: 220px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                font-family: 'Quicksand',sans-serif;
                font-size: 14px;
                margin-top: 2px;
            }

            .selectClass{
                pointer-events: none;
                touch-action: none;


                .classToolId{
                  pointer-events: all;
                  touch-action: unset;
                  margin-top: 10px;
                }

                select, input{
                    border: none;
                    background-image: none;
                    padding: 0;
                }

                span{
                    display: none;
                }
            }



            .profile{
                display: flex;
                justify-content: flex-start;
                /* width: 100%; */
                /* max-width: 59%; */

                /* select{
                    width: 220px;
                    &:last-child{
                        display: none;
                    }
                } */

                /* .role{
                    width: 100%;
                    max-width: 34%;
                } */

                .active{
                    background-color: #00D36A;
                    color: #fff !important;
                    font-size: 18px;
                    font-weight: 500;
                    width: 126px;
                    border: none;
                    margin-left: 240px;
                }
            }

            input{
                width: 460px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                padding: 0 10px;
                margin-bottom: 15px;
                background-color: transparent;
                font-family: 'Quicksand', sans-serif;
                font-size: 14px;
                margin-top: 2px;
            }

            ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: #87868F;
            }

            .addInput{
                width: 128px;
                height: 32px;
                border-radius: 26px;
                margin: 0 24px;
                background: transparent;
                border: 1px solid #B2B2B7;
                color: #87868F;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
            }

            input:invalid{
                width: 460px;
                height: 32px;
                border-radius: 26px;
                /* border: 1px solid red; */
                padding-left: 10px;
                margin-bottom: 15px;
            }

            .inputs{
                display: flex;



            .lineInputs{


                margin-right: 23px;

                button{
                    margin: 24px 0 0 -6px;
                    width: 175px;
                    padding: 0 12px;
                    margin-bottom: 48px;
                }

                .gender{
                    width: 243px;
                }

                .MuiInput-input-14 {
                    width: 215px;
                    border: none;
                    height: 19px;
                    margin: 0;
                }

                .MuiFormControl-root-30 {
                    border: 1px solid;
                    border-radius: 26px;
                    border: 1px solid #B2B2B7;
                }

                input{
                    width: 220px;
                }

                select.userPhoneTypeId{
                    width: 300px;
                }

            }

            p{
                font-size: 11px;
                color: #87868F;
                margin-top: 22px;
            }

        }


            .telephone{
                input{
                    width: 220px;
                }

                button.addInput{
                    margin: 20px 0 0 0;
                    font-family: 'Work Sans', sans-serif;
                }
            }

            button.addInput{
                width: 132px;
                height: 32px;
                border-radius: 26px;
                margin-left: 20px;
                background: transparent;
                border: 1px solid #403F4C;
                color: #403F4C;
                font-family: 'Work Sans', sans-serif;
                font-size: 14px;
                cursor: pointer;
                margin-bottom: 22px;
                font-weight: 500;
            }

            button.password{
                width: 158px;
                height: 32px;
                border-radius: 26px;
                margin-left: 0;
                background: transparent;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                font-family: 'Quicksand', sans-serif;
                font-size: 14px;
                cursor: pointer;
                font-weight: 100;
                margin: 2px 0 44px 0;
            }

            .notification{
                display: flex;

                .switch__container{
                    margin: 5px 0 0 23px;

                    span{
                        margin-left: 47px;
                        font-size: 12px;
                        color: #707070;
                        font-family: 'Quicksand', sans-serif;
                    }
                }

                span.delete{
                    margin: 11px 0 0 0;
                    width: 55px;
                    font-weight: bold;
                }
            }

            .switchBox{
                display: flex;

                .labelNotify{
                    display: flex;
                    flex-direction: column;
                    width: auto !important;

                    .doubleClick{
                      color: #ccc !important;
                    }
                  }
            }



            // select{
            //     width: 220px;
            //     height: 32px;
            //     border-radius: 26px;
            //     border: 1px solid #403F4C;
            //     padding-left: 10px;
            //     margin-bottom: 15px;
            // }

            .selects{
                display: flex;
                flex-direction: row;

            }

            .lineSelect{
                margin: 0 25px 0 0;

                p{
                    font-size: 11px;
                    margin-top: 22px;
                    color: #403F4C;
                }
            }

            span.delete {
                color: red;
                font-size: 10px;
                font-weight: bold;
                margin-top: 30px;
                float: left;
            }


            button{
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-weight: bold;
                font-size: 11px;
                border-radius: 26px;
                width: 81px;
                height: 38px;
                margin: 15px 0 42px 0;
                cursor: pointer;
            }

            button.jsx-4179805763 {
                width: 460px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin: 0 0 1px 0 !important;
                background: #B2B2B7;
                border-radius: 0;
            }
            button.focus.jsx-4179805763  {
                background: #B2B2B7;
            }

            button.delete{
                width: 83px;
                height: 22px;
                border-radius: 26px;
                background: transparent;
                border: none;
                color: #FF5666;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 25px 0 20px 7px;

            }

        }

        /** Button Save **/
        .buttonSave{
            display: flex;
            justify-content: flex-end;

            button{
                width: 81px;
                height: 38px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: bold;
                margin: 24px 0 30px 0;
                font-family: 'Work Sans',sans-serif;
            }
        }

        input.jsx-4179805763  {
            width: 480px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            // margin-top: 21px;
        }

        /** Plans **/
        .planBox{

            .box {
                flex-direction: column;


                .buttons{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-end;
                    margin: 25px 35px 25px 0;
                    padding: 0 15px 0 15px;
                    cursor: pointer;

                    button {
                        background-color: transparent;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 71px;
                        height: 32px;
                        margin-top: 9px;
                        cursor: pointer;

                        &:last-child{
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 81px;
                            height: 38px;
                            margin-top: 5px;
                            margin-left: 15px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .PlansBox {
              display: flex;
              width: 100%;
              justify-content: space-between;
              align-items: flex-start;


                &:first-child{
                    margin-bottom: 0;
                    border-bottom: none;
                    padding-bottom: 0;
                }

                &:last-child{
                    border-bottom: none;
                }

                .chosenPlan {
                    flex-direction: row;
                    display: flex;
                    margin: 0;
                    width: 100%;
                    height: 80px;
                    padding: 10px 0 0 15px;
                    margin-left: 13px;
                    flex-wrap: wrap;

                h2 {
                        padding: 0 30px 0 0;
                        font-size: 15px;
                        color: #403F4C;
                        font-weight: bold;
                        margin: 0;
                    }

                    h3 {
                        padding: 0;
                        margin: 0;
                        font-size: 18px;
                        color: #403F4C;
                        font-weight: bold;
                    }

                    p {
                        color: #403F4C;
                        font-size: 15px;
                        padding: 0;
                        margin: 0 0 5px 0;
                    }

                    button {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 86px;
                        height: 28px;
                        margin-top: 5px;
                        cursor: pointer;

                        &:last-child {
                            background-color: #fff;
                            border: 1px solid #B2B2B7;
                            color: #B2B2B7;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 93px;
                            height: 28px;
                            margin: 5px 0 26px 10px;
                            cursor: pointer;
                        }
                    }

                }

                .last{
                    margin-bottom: 20px;
                }

                .plans {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    max-width: 170px;
                    width: 40%;


                    &:nth-child(2) {
                      max-width: 400px;
                    }

                    .changePlan {
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        padding-left: 10px;

                        h2 {
                            color: #403F4C;
                            font-size: 18px;
                            font-weight: bold;
                            width: max-content;
                            margin: 0 !important;
                        }

                        button {
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 86px;
                            height: 22px;
                            margin-top: 5px;
                            margin-right: 5px;
                            cursor: pointer;
                            font-family: 'Quicksand', sans-serif;

                            &:last-child {
                                background-color: #fff;
                                border: 1px solid #B2B2B7;
                                color: #B2B2B7;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 93px;
                                height: 22px;
                                margin-top: 5px;
                                cursor: pointer;
                            }

                            .fa{
                                margin-left: 10px;
                            }
                        }
                    }

                    /** Controle Plano **/
                    .controlPlan{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        width: 100%;
                        gap: 40px;
                        flex-wrap: wrap;

                        .infos{
                            margin-bottom: 10px;
                            text-align: center;
                        }

                        h2{
                            font-size: 13px;
                            color: #9E9EA4;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand', sans-serif;
                        }

                        h3{
                            font-size: 14px;
                            color: #403F4C;
                            margin: 3px 0 0 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;
                            text-align: left;
                            max-width: 100%;
                        }

                        span{
                            color: #004FFF;
                            font-size: 22px;
                            font-weight: bold;

                            &:last-child{
                                color: #004FFF;
                                font-size: 14px;
                                font-weight: 50
                            }
                        }
                    }

                    /** Números **/
                    .numbers{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-top: -3px;
                    }

                    /** Stock **/
                    .stock{
                      display: flex;
                      width: 100%;
                        hr {
                            height: 4px;
                            background-color: #004FFF;
                            width: 100%;
                            border: none;
                            margin: 9px 0 10px 0;
                            opacity: 1;
                        }

                        span{
                            color: #004FFF;
                            font-size: 12px;
                        }
                    }


                    /** Pagamento **/
                    .payment{
                        flex-direction: column;
                        margin-top: 7px;
                        width: auto;

                        h2{
                            font-size: 15px;
                            color: #87868F;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                        }

                        h3{
                            font-size: 18px;
                            color: #87868F;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;
                            display: flex;
                            align-items: center;

                            img{
                                margin-right: 8px;
                            }
                        }

                        button{
                            background-color: transparent;
                            border: 1px solid #FF5666;
                            color: #FF5666;
                            font-size: 11px;
                            border-radius: 26px;
                            width: auto;
                            height: 22px;
                            margin-top: 8px;
                            padding: 0 12px 0 12px;
                            cursor: pointer;
                        }

                        select {
                            width: 100%;
                            height: 32px;
                            border-radius: 26px;
                            border: 1px solid #403F4C;
                            padding-left: 10px;
                            margin-bottom: 15px;
                            color: #403F4C;
                            margin-right: 10px;
                            opacity: 0.4;
                        }
                    }


                    /** Valores **/
                    .value {
                        margin-top: 8px;

                        h2{
                            font-size: 15px;
                            color: #87868F;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                        }

                        h3{
                            font-size: 18px;
                            color: #403F4C;
                            font-weight: normal;
                            margin-top: 4px;
                            margin: 0;
                            padding: 0;
                            max-width: 100%;
                            text-align: left;
                        }

                        button{
                            background-color: #fff;
                            border: 1px solid #787780;
                            color: #403F4C;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 94px;
                            height: 22px;
                            margin-top: 8px;
                            cursor: pointer;
                        }

                    }

                    &:nth-child(2) {
                        flex-direction: column;
                    }

                    &:last-child button{

                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #787881;
                        font-size: 11px;
                        border-radius: 26px;
                        width: auto;
                        height: 22px;
                        margin-top: 5px;
                        cursor: pointer;
                        font-family: 'Quicksand', sans-serif;
                        padding: 0 7px 0 7px;

                        .fa{
                            margin-left: 7px;
                        }
                    }

                    .buttons{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 25px;
                        padding: 0 15px 0 15px;
                        cursor: pointer;

                        button{
                            background-color: transparent;
                            border: 1px solid #787780;
                            color: #403F4C;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 71px;
                            height: 38px;
                            margin-top: 8px;
                            cursor: pointer;

                            &:last-child{
                                background-color: #004FFF;
                                border: none;
                                color: #fff;
                                font-weight: bold;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 81px;
                                height: 38px;
                                margin-top: 5px;
                                cursor: pointer;
                            }
                        }

                        .cancel{
                            button{
                                background-color: transparent;
                                border: 1px solid #FF5666;
                                color: #FF5666;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 104px;
                                height: 22px;
                                margin-top: 5px;
                                cursor: pointer;
                            }
                        }
                    }

                }

                .planCancel{
                    background-color: #FF5666;
                    color: #fff;
                    padding: 4px 10px 0 10px;
                    height: 23px;
                    margin-top: 32px;
                    font-size: 15px;
                    font-weight: bold;
                    font-family: 'Quicksand', sans-serif;
                }
            }
        }

        /** box Big **/
        .boxBig {
          width: 100%;
          display: flex;
          gap: 26px;
          margin: 0 auto;
          flex-direction: column;
          flex-wrap: wrap;

          border-bottom: 1px solid #ccc;


                &:last-child {
                    border-bottom: none !important;
                }


            .itemBox {
                display: flex;
                justify-content: space-between;
                width: 100%;
                flex-wrap: wrap;
                flex-direction: row;



                h5{
                    padding: 0;
                    margin: 0;
                    font-weight: bold;
                    color: #87868F;
                }

                span{
                    color: #004FFF;
                }

                .levelTop {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;
                    width: 100%;
                    max-width: 160px;

                    .levelTopLinguage {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        .boxLanguage {
                            display: flex;
                            width: 100%;
                            justify-content: space-between;
                            flex-direction: column;

                            h5{
                                padding: 0;
                                margin: 0;
                                color: #87868F;
                            }

                            .language {
                                display: flex;
                                margin: 7px 0 13px 0;
                                align-items: center;

                                img {
                                    margin: 0 8px 0 0;
                                }

                                h5{
                                    font-size: 18px;
                                    color: #87868F;
                                    margin: 0;
                                    padding: 0;
                                    font-family: 'Quicksand',sans-serif;
                                    font-weight: 100;
                                }
                            }
                        }
                    }

                    .columLevel {
                        justify-content: flex-end;
                        display: flex;
                        width: 100%;

                        h5 {
                            text-align: right;
                            padding: 0;
                            margin: 0;
                            color: #87868F;
                        }
                    }

                }

                .another-grades{
                  align-items: center;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }

                .grades {
                    display: flex;
                    flex-direction: row;
                    align-items: center;


                    h6 {
                        margin:  0 10px 0 0;
                        color: #87868F;
                        font-size: 15px;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: bold;
                    }

                    h5{
                        padding: 0;
                        margin: 0;
                        color: #87868F;
                        font-size: 14px;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: normal;
                        font-weight: bold;
                        text-align: center;

                        span {
                            color: #004FFF;
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        /** Notifications **/
        .infoNotification {
            width: 100%;

            h2 {
                color: #403F4C;
                font-size: 18px;
                margin: 40px 0 0 52px;
                font-weight: 100;
                font-family: 'Quicksand', sans-serif;
            }

            ul {
                margin: 40px 0 0 57px;
                display: flex;
                width: 88%;
                flex-direction: column;

            li {
                    display: flex;
                    align-items: center;
                    padding: 0;
                    margin: 0;
                    height: 50px;

                    span {
                        width: 175px;
                        /* //margin: -23px 25px 0 0; */
                        color: #403F4C;
                        /* //font-weight: bold; */
                        font-size: 16px;
                        font-family: 'Quicksand', sans-serif;
                    }

                }
            }
        }

        /** Manage Available Hours **/
        .topManage {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            margin: 15px 25px 0 0;
            align-items: center;

            h2 {
                font-size: 18px;
                color: #403F4C;
                font-weight: normal;
            }

            button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 14px;
                font-weight: bold;
                border-radius: 26px;
                width: auto;
                height: 38px;
                margin-top: 5px;
                padding: 12px;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
            }
        }

        .manage {
            display: flex;
            width: 100%;
            justify-content: start;
            flex-direction: column;

            .day {
                display: flex;
                align-items: center;
                flex-direction: row;
                margin: 10px 0 10px 0;
            }

            h2 {
                font-size: 14px;
                color: #004FFF;
                font-weight: 500;
                font-family: 'Work Sans', sans-serif;
            }

            p{
                color: #C5C5C5
            }

            button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 11px;
                font-weight: bold;
                border-radius: 26px;
                width: 44px;
                height: 22px;
                margin: 5px 0 0 16px;
                cursor: pointer;
            }

            ul {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                list-style: none;
                padding: 0;

                .configDay {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: row;
                    margin: 0 30px 0 0;
                }

                li {
                    font-size: 14px;
                    color: #403F4C;
                    padding: 0 5px 0 0;

                span {
                        color: red;
                        font-size: 12px;
                    }

                    button {
                        background-color: white;
                        width: 55px;
                        cursor: pointer;
                        color: red;
                        font-size: 12px;
                        margin: 0;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                    }

                }
            }

        }

        /** Edit **/
        .selectDays{
            margin: 35px 0 0 28px;

            h2 {
                color: #403F4C;
                font-size: 28px;
                margin: 0;
                font-family: 'Quicksand',sans-serif;
                font-weight: 100;
            }

            h3 {
                color: #403F4C;
                font-size: 12px;
                margin: 0;
                max-width: 72%;
            }

            h4 {
                color: #403F4C;
                font-size: 14px;
                margin: 25px 0 0 0;
            }

            ul {
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                justify-content: start;
                list-style: none;
                padding: 0;

                li {
                    margin: 0 10px 0 0;
                    padding: 5px 0 0 0;

                    span{
                        font-size: 12px;
                        color: #403F4C;
                        margin-top: 5px;
                        font-family: 'Quicksand', sans-serif;
                    }

                    button {
                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #B2B2B7;
                        font-size: 14px;
                        border-radius: 26px;
                        width: 76px;
                        height: 28px;
                        margin-top: 0;
                        cursor: pointer;
                    }

                    button.active {
                        background-color: #004FFF;
                        color: #fff;
                        border: #004FFF;
                    }
                }
            }

            .time{
                ul {
                    list-style: none;
                    margin-left: 24px;

                    li {
                        display: flex;
                        flex-direction: column;
                    }
                }

                select {
                    background-color: #004FFF;
                    color: #fff;
                    border-radius: 26px;
                    border: 0;
                    width: 114px;
                    height: 28px;
                    padding-left: 10px;
                    font-family: 'Work Sans', sans-serif;
                    font-size: 14px;
                    margin-top: 5px;
                }
            }

            .addSlot{
                button {
                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #B2B2B7;
                    font-size: 14px;
                    border-radius: 26px;
                    width: 100%;
                    height: 28px;
                    margin: 20px 0 36px 24px;
                    cursor: pointer;
                    font-family: 'Work Sans',sans-serif;
                    font-weight: 500;
                    padding: 0 10px 0 10px;
                }
            }

            .buttons {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                margin: 25px;
                padding: 0 15px 0 15px;
                cursor: pointer;
                font-family: 'Quicksand', sans-serif;

                button {
                    background-color: transparent;
                    border: 1px solid #787780;
                    color: #403F4C;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: auto;
                    height: 28px;
                    margin-top: 9px;
                    cursor: pointer;

                    .fa{
                        margin-right: 5px;
                    }

                    &:last-child {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 81px;
                        height: 38px;
                        margin-left: 15px;
                        margin-top: 5px;
                        cursor: pointer;
                    }
                }
            }
        }

        .pagamento{
            display: flex;
        }

        .inputManage{
            border-color: #B2B2B7 !important;
        }

    }




`;

export const TableCss = styled.div`
    margin-top: 21px;

    .boxTable{
        display: flex;
        width: 100%;
        padding: 0 12px 0 10px;
        background-color: #fff;
        justify-content: space-between;
        border: 1px solid;
        flex-direction: row;

        .boxItem{
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            h3{
                font-size: 12px;
                color: #403F4C;
                font-weight: bold;
            }

            .itemTop{
                h3{
                    margin: 11px 139px 0 0;
                }
            }

        }
        hr{
            margin-top: 0;
        }
    }


    table{
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0 15px 0;

        tr{
            text-align: left;
            height: 35px;

            th{
                color: #403F4C;
                font-size: 12px;
                font-weight: bold;
            }

            :nth-child(2){
                border-top: 1px solid #B2B2B7;
            }
        }



        td {
            border-bottom: 1px solid #B2B2B7;
            height: 33px;
            font-size: 14px;
            color: #403F4C;
            font-weight: 500;
            font-family: 'Work Sans', sans-serif;

            span{
                color: #0ED572;
                font-weight: bold;
            }
            .inativo{
                color: #FF5666;
                font-weight: bold;
            }
            button{
                background-color: transparent;
                border: 1px solid #B2B2B7;
                border-radius: 26px;
                color: #87868F;
                font-size: 11px;
                width: 58px;
                height: 22px;
                float: right;
                cursor: pointer;
            }
        }
    }

`;

export const User = styled.div`
    .userName{
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #87868F;
            margin:25px 0 0 199px;
            font-family: 'Quicksand', sans-serif;
        }
    }

    .avatarRound {
        border-radius: 50%;
        object-fit: cover;
    }


    .viewUser{
        display: flex;
        width: 100%;
        flex-direction: row;
    }

    .MuiInput-underline-15:before {
        border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
        border-bottom: none;
    }

    /** changePhoto**/
    .changePhoto{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 40px 60px 0 25px;

        h2{
            color: #403F4C;
            font-size: 14px;
            margin: 0 0 10px 0;
        }

        .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 11px;
            font-weight: 500;
            opacity: 0.7;
            display: flex;
            align-items: center;
            justify-content: center;

            span{
                align-items: center;
                display: flex;
            }

            input.upload {
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 20px;
                cursor: pointer;
                opacity: 0;
                filter: alpha(opacity=0);
            }
        }

        span{
            img{
                padding: 0 5px 0 0;
            }
        }
    }

    /** Form **/
    .formulario{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin: 40px 100px 0 0;
        width: 100%;

        /* .react-inputs-validation__textbox__container___3KXOM{
            width: 45%;
            margin-right: 5px;
        } */

        .addEmail{
            display: flex;

            input{
                width: 460px;
            }
        }

        .label{
            margin: 0 0 -15px 0;
        }


        label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
        }

        span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
        }


        select{
            width: 220px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
        }


        .profile{
            display: flex;
            justify-content: flex-start;
            margin-bottom: 25px;
            /* width: 100%; */
            /* max-width: 59%; */

            /* select{
                width: 220px;
                &:last-child{
                    display: none;
                }
            } */

            /* .role{
                width: 100%;
                max-width: 34%;
            } */

            .active{
                background-color: #00D36A;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
                font-family: 'Quicksand', sans-serif;
            }

            .inactive{
                background-color: red;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
            }
        }


        input{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            padding-left: 10px;
            margin-bottom: 15px;
            font-size: 14px;
            font-family: 'Quicksand', sans-serif;
        }

        .genderBox{
            margin-bottom: 25px;
        }


        .addInput{
            width: 110px;
            height: 32px;
            border-radius: 26px;
            margin-left: 20px;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            font-family: 'Work Sans', sans-serif;
            font-size: 14px;
            cursor: pointer;
        }

        .inputs{
            display: flex;

            .lineInputs{
                margin-right: 23px;

                button{
                    margin: 21px 0 0 0
                }

                .gender{
                    width: 243px;
                }


                .MuiInput-input-14 {
                    width: 215px;
                    border: none;
                    height: 19px;
                    margin: 0;
                }

                .MuiFormControl-root-30 {
                    border: 1px solid;
                    border-radius: 26px;
                    border: 1px solid #B2B2B7;
                }

                input{
                    width: 220px;
                }

                select.userPhoneTypeId{
                    width: 300px;
                }

            }

            p{
                font-size: 11px;
                color: #87868F;
                margin-top: 22px;
            }
        }

        button.delete{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 20px;
        }

        button.deleteLast{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 0;
            font-family: 'Quicksand', sans-serif;
        }

        .removephone{
            margin: 0 0 0 -25px;
        }


    }

    .button{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
            width: 81px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;

            .fa{
                margin-right: 3px;
            }
        }
    }

    input.jsx-4179805763  {
        width: 226px !important;
        height: 32px;
        border-radius: 26px;
        border: 1px solid #B2B2B7;
        padding-left: 10px;
        margin-bottom: 0;
        margin-top: 0;
    }

    button.jsx-4179805763  {
        margin: 0 0 1px 0 !important;
    }

    input[type='number'] {
        -moz-appearance:textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

`;

export const FilterUser = styled(User)`
    width: 100%;

    .filterContent {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        padding: 20px;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);


        h2 {
            font-size: 20px;
            font-weight: 400;
            color: #87868F;
            font-family: 'Quicksand', sans-serif;
            .fa{
                margin: 0 5px 0 0;
            }
        }

        .inativo {
            color: #FF5666;
            font-weight: bold;
        }


        .formulario {
            flex-direction: row;
            margin: 10px 0 0 0;


            .lineInput{
                display: flex;
                flex-direction: column;
                margin: 0 16px 0 0;
                width: 100%;
                min-width: 10%;
            }

            input {
                width: auto;
            }

            select{
                width: auto;
            }
        }

        .button {
            display: flex;
            justify-content: flex-end;
            width: 100%;

            button{
                width: 149px;
                height: 38px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: bold;
                margin: 0 0 20px 0;
            }
        }

        .boxButton{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

        .buttons{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-family: 'Quicksand', sans-serif;
            margin-bottom: 0px ;

            button{
                width: 84px;
                height: 28px;
                border-radius: 26px;
                background: #fff;
                border: 1px solid #B2B2B7;
                color: #787780;
                cursor: pointer;
                font-size: 11px;
                font-weight: 500;
                margin: 18px 0 0 0;
                margin-right: 10px;
                font-family: 'Quicksand',sans-serif;

                &:last-child{
                    width: auto;
                    height: 32px;
                    border-radius: 26px;
                    background: #004FFF;
                    border: 1px solid #004FFF;
                    color: #fff;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                    padding: 0 12px 0 12px;
                }


                &:disabled,
                    button[disabled]{
                    width: 58px;
                }

            }

            button.save {
                width: 81px;
                height: 22px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 10px 18px 0 0;
                font-family: 'Work Sans', sans-serif;
            }


        }
    }
`;

export const InfoUser = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

    .wrapperTitle {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 5px;
        padding-right: 51px;

        p {
            color: #000;
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
        }
    }

    .wrapperResult {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 20px;

        div {
            display: flex;
            align-items: center;
            flex-direction: row;
            gap: 10px;

            p {
                color: #000;
                font-size: 13px;
                font-weight: 400;
                line-height: 15px;
            }

            .fullBorder {
                padding: 6px 7px;
                border-radius: 6px;
                border: 1px solid #B2B2B7;
            }
        }
    }
`;

export const TableUser = styled.div`
    margin-top: 21px;

    .bigBoxTableStudent{
        width: auto;
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        table{
            width: 100%;
            border: none;
            border-collapse: collapse;
            background-color: #ffffff;

            thead {
                border-bottom: 1px solid #B2B2B7;
            }

            tr{
                text-align: left;
                height: 35px;

                th{
                    color: #403f4c;
                    font-size: 12px;
                    font-weight: bold;
                }

                :nth-child(2){
                    border-top: 1px solid #B2B2B7;
                }
            }

            td {
                position: relative;
                border-bottom: 1px solid #B2B2B7;
                height: 33px;
                font-size: 14px;
                color: #403f4c;
                font-weight: 400;
                font-family: "Work Sans", sans-serif;
                padding: 4px 0;

                .activo{
                    color: #0ED572;
                    font-weight: bold;
                }
                .inativo{
                    color: #FF5666;
                    font-weight: bold;
                }
                button{
                    background-color: transparent;
                    border: 1px solid #B2B2B7;
                    border-radius: 26px;
                    color: #87868F;
                    font-size: 11px;
                    width: 58px;
                    height: 22px;
                    float: right;
                    cursor: pointer;
                }
            }
        }
    }
`;
